import React, { ReactElement } from 'react';
import { Slider as AntSlider } from 'antd';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';

interface SliderProps {
  value?: number;
  onChange?: (value: number) => void;
  onChangeComplete?: (value: number) => void;
  min?: number;
  max?: number;
  step?: number | null;
  marks?: Record<number, React.ReactNode>;
  disabled?: boolean;
  className?: string;
  included?: boolean;
  showTooltip?: boolean;
}

function Slider({
  value,
  onChange,
  onChangeComplete,
  min = 0,
  max = 100,
  step = 1,
  marks,
  disabled,
  className,
  included = true,
  showTooltip = true,
}: SliderProps): ReactElement {
  const handleChange = (newValue: number | number[]) => {
    if (onChange && typeof newValue === 'number') {
      onChange(newValue);
    }
  };

  const handleChangeComplete = (newValue: number | number[]) => {
    if (onChangeComplete && typeof newValue === 'number') {
      onChangeComplete(newValue);
    }
  };

  return (
    <StyledSlider
      value={value}
      onChange={handleChange}
      onChangeComplete={onChangeComplete ? handleChangeComplete : undefined}
      min={min}
      max={max}
      step={step === null ? undefined : step}
      marks={marks}
      disabled={disabled}
      className={className}
      included={included}
      tooltip={showTooltip ? undefined : { open: false }}
    />
  );
}

const StyledSlider = styled(AntSlider)`
  .ant-slider-rail {
    background-color: ${colorsPalette.lightGray300};
  }

  .ant-slider-track {
    background-color: ${colorsPalette.dustyBlue500};
  }

  .ant-slider-handle {
    border-color: ${colorsPalette.dustyBlue500};

    &::after {
      box-shadow: 0 0 0 2px ${colorsPalette.dustyBlue500};
    }

    &:hover,
    &:focus {
      border-color: ${colorsPalette.dustyBlue500};

      &::after {
        box-shadow: 0 0 0 4px ${colorsPalette.dustyBlue500};
      }
    }
  }

  .ant-slider-handle.ant-tooltip-open {
    border-color: ${colorsPalette.dustyBlue500};
  }

  .ant-slider-dot {
    border-color: ${colorsPalette.lightGray300};

    &.ant-slider-dot-active {
      border-color: ${colorsPalette.dustyBlue500};
    }
  }

  .ant-slider-mark-text {
    color: ${colorsPalette.gray600};
  }
`;

export default Slider;
